/*
 *
 * Parking constants
 *
 */

export const GUEST_PARKING = '2970980721000';
export const TENANT_PARKING = '2971072342000';
export const LOADING_AND_UNLOADING_PARKING = '2971075902000';
